import { FiCheckCircle } from "react-icons/fi";

function Success({ message, type }) {
  return (
    <div className="text-green-600 font-medium flex items-center">
      <FiCheckCircle className="mr-2 text-2xl stroke-green-600 stroke-[3px]"></FiCheckCircle>
      <p>{message}</p>
    </div>
  );
}

export default Success;
